<template>
  <div class="customer-manage">
    <div class="searchArea">
      <el-form inline>
        <el-form-item>
          <el-input class="search-input" v-model.trim="customerName" style="width: 150px" clearable
                    placeholder="请输入客户名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="customerLevel" placeholder="请选择客户级别" style="width: 150px" clearable>
            <el-option
                v-for="item in customerLevelOptions"
                :key="item.id"
                :label="item.description"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="followupState" placeholder="请选择跟进状态" style="width: 150px" clearable>
            <el-option
                v-for="item in followStateOptions"
                :key="item.id"
                :label="item.description"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="informState" placeholder="请选择报备状态" style="width: 150px" clearable>
            <el-option
                v-for="item in informStateOptions"
                :key="item.id"
                :label="item.description"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-date-picker
              style="width: 270px"
              v-model="dateRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="至"
              start-placeholder="创建开始日期"
              end-placeholder="创建结束日期"
              :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button type="plain" plain @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div>
        <auth-button code="KHCC" plain @click="checks">报备查询</auth-button>
        <auth-button code="KHXJ" type="primary" @click="addCust">新建客户</auth-button>
      </div>
    </div>

    <el-form inline class="mb-15">
      <auth-button code="KHFRGH" type="primary" size="mini" plain @click="otherOperate('sea')" class="el-icon-finished">放入公海</auth-button>
      <auth-button code="GGGJZT" type="primary" size="mini" plain @click="otherOperate('state')" class="el-icon-edit">更改跟进状态</auth-button>
      <auth-button code="KHSC" type="danger" size="mini" plain @click="otherOperate('delete')" class="el-icon-delete">删除</auth-button>
    </el-form>

    <div class="list-table">
      <new-table ref="newTable" firstType="selection" :data="tableData" :columns="columns" :pages="pages"></new-table>
    </div>
    <Checks ref="Checks" @report="getData"></Checks>

    <selectFollowState ref="selectFollowState" @complete="getData"/>
  </div>
</template>

<script>
import { CustomerApis, DictionaryApis } from "@/apis";
import NewTable from "@/components/new-table.vue";
import { DictionaryKey } from "@/utils/enum";
import Checks from "@/views/customer-manage/customer/checks";
import selectFollowState from "./select-follow-state"

export default {
  data() {
    return {
      customerName: "",
      customerLevel: "",
      followupState: "",
      informState: '',
      dateRange: '',
      customerLevelOptions: '',
      followStateOptions: '',
      informStateOptions: [
        {
          id: 1,
          description: '已报备',
        },
        {
          id: 0,
          description: '未报备',
        },
      ],
      tableData: [],
      columns: [
        {label: "客户名称", prop: "customerName", width: 240,
          render: (h,{ row }) => {
            return <div style="color: #3d9cfc;cursor: pointer" onClick={ () => this.$router.push(`/customer-detail?id=${row.id}`) }>
              { row.customerName }
            </div>
          }
        },
        {label: "网址", prop: "url", },
        {label: "客户级别", prop: "customerLevelName" },
        {label: "地址",
          render: (h,{ row }) => row.province+row.city+row.district
        },
        {label: "最新跟进时间", prop: "followLastUpdateTime", },
        {label: "创建时间",
          render: (h,{ row }) => row.createTime && row.createTime.slice(0,10)
        },
        {label: "跟进状态",
          render: (h,{ row }) => {
          switch (row.followupStateName) {
            case '待跟进': return <div style="color: #ffc107">待跟进</div>;
            case '跟进中': return <div style="color: #6f2aed">跟进中</div>;
            case '已完成': return <div style="color: #17a00e">已完成</div>;
            default: return row.followupStateName;
          }
          }
        },
        {label: "报备状态",
          render: (h,{ row }) => row.isReport?<div style="color: #17a00e">已报备</div>:<div style="color: #ffc107">未报备</div>
        },
        {label: "报备人", prop: "reportUserName" },
        {label: "报备日期",
          render: (h,{ row }) => row.reportDate && row.reportDate.slice(0,10)
        },
        {label: "报备到期日期",
          render: (h,{ row }) => row.reportEndDate && row.reportEndDate.slice(0,10)
        },
        // {label: "服务期内",
        //   render: (h,{ row }) => row.isServicePeriod?'是':'否'
        // },
        // {label: "服务期限", prop: "followupStateName" },
        {
          label: "操作",fixed: "right", width: '110',align: 'center',
          render: (h, { row }) => {
            return <div>
              <el-button v-show={ !row.isReport } type="text" style="color: #3d9cfc;" onClick={()=>this.report(row.id)}>
                报备
              </el-button>

              <el-button v-show={ row.isReport } type="text" style="color: #f41127;margin-left: 0;" onClick={()=>this.cancelReport(row.id)}>
                取消报备
              </el-button>

              <el-button type="text" code="AssignRoles" onClick={()=>this.$router.push(`/customer-detail?id=${row.id}`)}>
                详情
              </el-button>
            </div>
          },
        },
      ],
      pages: {
        props: {
          "page-size": 20,
          "current-page": 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.currentChange(p);
          },
          "size-change": this.sizeChange
        },
      },
    }
  },
  mounted() {
    this.getCustomerLevel();
    this.getFollowState();
  },
  methods: {
    checks() {
      this.$refs.Checks.open();
    },
    getCustomerLevel() {
      DictionaryApis.getDictValueByKey(DictionaryKey.CustLevel).then(res=>{
        this.customerLevelOptions = res;
      });
    },
    getFollowState() {
      DictionaryApis.getDictValueByKey(DictionaryKey.FollowState).then(res=>{
        this.followStateOptions = res;
        if(this.$route.params.status === '待跟进') {
          this.followupState = this.followStateOptions[2].id;
        } else {
          this.followupState = '';
        }
        this.getData();
      });
    },
    getData() {
      this.$refs.newTable.clearSelection();
      const params = {
        isReport: `${ this.informState }` || -1,
        customerName: this.customerName,
        customerLevel: this.customerLevel || -1,
        followupState: this.followupState || -1,
        startTime: this.dateRange && this.dateRange[0] || '',
        endTime: this.dateRange && this.dateRange[1] || '',
        pageIndex: this.pages.props["current-page"],
        pageSize: this.pages.props["page-size"],
      }
      CustomerApis.getCustomerList(params).then(res => {
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      })
    },
    addCust() {
      this.$router.push("/add-customer")
    },
    otherOperate(key) {
      let sel = this.$refs.newTable.$refs.table.selection;
      if( sel.length ) {
        let listId = sel.map(s => s.id);
        switch (key){
          case 'sea': this.putInSea(listId);break;
          case 'state': this.changeState(sel);break;
          case 'delete': this.delCustomers(sel);break;
          default:break;
        }
      } else {
        this.$message.warning(`请先选择客户！`)
      }
    },
    putInSea(listId) {
      this.$confirm('确定将所选客户放入公海吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`/Crm/Customer/ModifyCustomerIsShareData`,{
          listId: listId
        }).then(() => {
          this.$message.success(`放入公海成功！`);
          this.onSearch();
        })
      }).catch(()=>{})

    },
    changeState(sel) {
      let followupStateList = sel.map(s => s.followupStateName);
      if( followupStateList.includes('已完成') ){
        this.$message.warning(`已完成的跟进状态不可更改！`);
      } else {
        let listId = sel.map(s => s.id);
        this.$refs.selectFollowState.open(listId);
      }
    },
    delCustomers(list) {
      const reportCust = list.find(item=>item.isReport)
      if(reportCust) return this.$message.warning(`客户 “${reportCust.customerName}” 已报备，不能删除`);
      this.$confirm('确定删除所选客户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`/Crm/Customer/DelCustomerData`,{
          listId: list.map(s => s.id)
        }).then(() => {
          this.$message.success(`删除成功！`);
          this.onSearch();
        })
      })
    },
    onSearch() {
      this.currentChange(1);
    },
    reset() {
      this.customerName = "";
      this.customerLevel = "";
      this.followupState = "";
      this.dateRange = "";
      this.informState = '';
      this.currentChange(1);
    },
    sizeChange(size) {
      this.pages.props["page-size"] = size;
      this.currentChange(1);
    },
    currentChange(p) {
      this.pages.props["current-page"] = p;
      this.getData();
    },
    // 报备
    report(id) {
      this.$confirm('确定报备吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`/Crm/Customer/SaveCustomerReport`,{customerId: id}).then(() => {
          this.$message.success(`报备成功！`);
          this.getData();
        })
      }).catch(()=>{})
    },
    // 取消报备
    cancelReport(id) {
      this.$confirm('确定取消报备吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(`/Crm/Customer/CancelcustomerReport`,{customerId: id}).then(() => {
          this.$message.success(`取消报备成功！`);
          this.getData();
        })
      }).catch(()=>{})
    }
  },
  components: {
    NewTable,
    Checks,
    selectFollowState
  },
}
</script>

<style scoped lang="scss">
.customer-manage {
  flex-direction: column;
  .searchArea {
    display: flex;
    justify-content: space-between;
    ::v-deep .el-date-editor {
      .el-range-separator {
        width: 27px;
      }
    }
  }
}
</style>
